import { apiServerFetchInvite } from '#/api/invite/apiFetchInvite';
import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import { authLoginRoute } from '#/modules/auth/routing/auth.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';
import { getAppRouteSearchParams } from '#/routing/utils/getAppRouteSearchParams';

import { AuthLoginPage } from './AuthLoginPage';

export async function loader({
  request,
  url,
  context,
}: HorizonAppRouteLoaderArgs<typeof authLoginRoute>) {
  const { invite: inviteId } = getAppRouteSearchParams({
    url,
    route: authLoginRoute,
  });

  const inviteData = inviteId
    ? await apiServerFetchInvite({ request, context })(inviteId)
    : null;

  return { invite: inviteData ? inviteData.invite : null };
}

export default function AuthLoginHorizonRoute({
  loaderData: { invite },
}: HorizonAppRouteComponentProps<typeof loader>) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Log In')}>
      <AuthLoginPage invite={invite} />
    </RouteModule>
  );
}
